"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
    points: "4 17 10 11 4 5",
    id: "polyline547",
    transform: "matrix(0.66149543,0,0,0.66149543,-1.4696394,4.2893476)",
    strokeWidth: "3.02345252",
    strokeMiterlimit: "4",
    strokeDasharray: "none"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
    x1: "6.1653337",
    y1: "16.929554",
    x2: "11.457298",
    y2: "16.929554",
    id: "line549",
    strokeWidth: "2",
    strokeMiterlimit: "4",
    strokeDasharray: "none"
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: "normal",
    fontStretch: "normal",
    fontSize: "8.96539879px",
    fontFamily: "Arial Rounded MT Bold",
    letterSpacing: "0px",
    wordSpacing: "0px",
    writingMode: "lr-tb",
    textAnchor: "start",
    fill: "currentColor",
    fillOpacity: "1",
    stroke: "none",
    strokeWidth: "1.49422431",
    id: "text561",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "m 11.384522,12.492745 q 0,0.711188 -0.302057,1.278 -0.297679,0.566812 -0.875527,0.887648 -0.577848,0.320838 -1.3702001,0.320838 -0.9499471,0 -1.5671938,-0.438478 Q 6.8317805,14.225264 6.5559894,13.701231 6.284576,13.17185 6.284576,12.674552 q 0,-0.288753 0.1619725,-0.491949 0.1663502,-0.208544 0.4202531,-0.208544 0.2057489,0 0.3458333,0.160418 0.144462,0.160418 0.2451476,0.475909 0.1225738,0.374309 0.2626582,0.625631 0.1444619,0.251322 0.4027425,0.417088 0.2582805,0.160419 0.6785336,0.160419 0.5778479,0 0.9368141,-0.326185 0.3633441,-0.331531 0.3633441,-0.823481 0,-0.390351 -0.1969939,-0.630979 Q 9.7122651,11.786904 9.4014529,11.65857 9.0950184,11.530234 8.5784573,11.385858 7.8867908,11.188009 7.4183838,10.925991 6.9543543,10.658628 6.6785633,10.20411 6.4071498,9.744243 6.4071498,9.0651381 q 0,-0.647021 0.288924,-1.1496653 0.288924,-0.5026444 0.8361285,-0.7700084 0.5472045,-0.2727113 1.287025,-0.2727113 0.5909809,0 1.0199892,0.1818075 0.4333855,0.1764603 0.7179325,0.475908 0.284546,0.2941004 0.415875,0.6202845 0.131329,0.3261841 0.131329,0.6363264 0,0.2834063 -0.16635,0.513339 -0.161972,0.2245861 -0.40712,0.2245861 -0.223259,0 -0.341456,-0.1336821 Q 10.075609,9.2522926 9.9399022,8.9421502 9.7647967,8.4983264 9.5196491,8.2523515 9.2745015,8.0010293 8.7316746,8.0010293 q -0.5034282,0 -0.8142403,0.2727113 -0.3064346,0.2673641 -0.3064346,0.6470211 0,0.2352804 0.1050633,0.4063929 0.1050633,0.1711138 0.288924,0.2941005 0.1838607,0.1229879 0.3720991,0.1925022 0.1882383,0.069516 0.6216243,0.2031967 0.5428269,0.155072 0.9805905,0.342226 0.4421411,0.187155 0.7485761,0.454519 0.310812,0.267364 0.48154,0.679105 0.175105,0.406393 0.175105,0.999941 z",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "8.96539879px",
      fontFamily: "Arial Rounded MT Bold",
      writingMode: "lr-tb",
      textAnchor: "start",
      strokeWidth: "2",
      strokeMiterlimit: "4",
      strokeDasharray: "none",
      id: "path563"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "m 17.442294,13.728757 q 0.284546,0.23528 0.621624,0.459866 0.337078,0.219239 0.446519,0.352921 0.109441,0.128334 0.109441,0.368961 0,0.171114 -0.131329,0.342226 -0.126951,0.171114 -0.310812,0.171114 -0.14884,0 -0.363344,-0.117643 -0.210126,-0.117642 -0.49905,-0.342226 -0.284547,-0.224586 -0.626002,-0.524034 -0.634758,0.3957 -1.558439,0.3957 -0.748576,0 -1.343934,-0.288754 -0.590981,-0.294101 -0.993724,-0.839523 -0.402742,-0.55077 -0.608491,-1.304737 -0.201371,-0.753967 -0.201371,-1.641614 0,-0.9036919 0.210126,-1.6576576 0.214504,-0.7539671 0.617247,-1.2833478 0.402742,-0.5293808 0.98059,-0.8074394 0.577848,-0.2834058 1.313291,-0.2834058 0.998101,0 1.711656,0.4972971 0.717932,0.4919498 1.085654,1.4063348 0.367721,0.9090379 0.367721,2.1389127 0,1.866201 -0.827373,2.957046 z m -1.019989,-0.86626 q 0.271413,-0.379656 0.398365,-0.898343 0.131329,-0.518687 0.131329,-1.203138 0,-0.8609135 -0.227637,-1.4918924 Q 16.496725,8.638145 16.072094,8.3173081 15.651841,7.991124 15.104636,7.991124 q -0.389609,0 -0.72231,0.1818076 -0.328322,0.1764601 -0.569092,0.5186866 -0.236393,0.3422251 -0.376477,0.8769536 -0.135707,0.5293812 -0.135707,1.1924442 0,1.352862 0.516561,2.085439 0.516561,0.72723 1.304536,0.72723 0.323945,0 0.665401,-0.165765 -0.205749,-0.187156 -0.516562,-0.37431 -0.306434,-0.187155 -0.420253,-0.288753 -0.113818,-0.101592 -0.113818,-0.288754 0,-0.160418 0.109441,-0.283405 0.109441,-0.122988 0.24077,-0.122988 0.398365,0 1.335179,0.812787 z",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "8.96539879px",
      fontFamily: "Arial Rounded MT Bold",
      writingMode: "lr-tb",
      textAnchor: "start",
      strokeWidth: "2",
      strokeMiterlimit: "4",
      strokeDasharray: "none",
      id: "path565"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "m 20.484168,7.8352636 v 5.7055484 h 2.779677 q 0.332453,0 0.507915,0.187155 0.180078,0.187155 0.180078,0.470561 0,0.288753 -0.175461,0.470561 -0.175461,0.17646 -0.512532,0.17646 h -3.310679 q -0.447888,0 -0.646438,-0.229934 -0.19393,-0.229933 -0.19393,-0.743271 V 7.8352636 q 0,-0.4812552 0.184696,-0.7218829 0.189313,-0.2406276 0.494062,-0.2406276 0.309367,0 0.49868,0.2406276 0.193932,0.2352804 0.193932,0.7218829 z",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "8.96539879px",
      fontFamily: "Arial Rounded MT Bold",
      writingMode: "lr-tb",
      textAnchor: "start",
      strokeWidth: "1.69606161",
      id: "path567"
    })]
  })]
}));